/** HENI's HubSpot portal (account) id, shared by every HubSpot form on the site. */
export const HUBSPOT_PORTAL_ID = '7886194';

/**
 * HubSpot form that opens an account-closure ticket. Its fields are `email`
 * and `message`; the ticket itself is created by the form's HubSpot workflow.
 */
export const CLOSE_ACCOUNT_HUBSPOT_FORM_GUID =
	'f1ed98c5-1f1d-4d96-a0fe-7aba93555930';

/**
 * CRM object each close-account field lives on (`0-1` contact, `0-5` ticket).
 * Both are contact properties on the form as configured; if `message` is
 * moved to a ticket property in HubSpot, flip it here.
 */
export const CLOSE_ACCOUNT_HUBSPOT_FIELD_OBJECT_TYPES = {
	email: '0-1',
	message: '0-1',
} as const;
